import React from 'react';
import { Button } from '@/components/ui/button';

interface LinkingModeToolbarProps {
  isActive: boolean;
  onCancel: () => void;
  onSave: () => void;
}

export const LinkingModeToolbar = ({
  isActive,
  onCancel,
  onSave,
}: LinkingModeToolbarProps) => {
  if (!isActive) return null;

  return (
    <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 z-30 bg-card2 border rounded-lg p-4 shadow-lg">
      <div className="flex items-center gap-4">
        <div className="text-sm">
          Click on a camera to add a new link or remove an existing link
        </div>
        <div className="flex gap-2">
          <Button
            onClick={onCancel}
            variant="outline"
            size="sm"
          >
            Cancel
          </Button>
          <Button
            onClick={onSave}
            size="sm"
          >
            Save
          </Button>
        </div>
      </div>
    </div>
  );
};